import { AddAPhoto, Delete } from "@mui/icons-material";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import AttachmentIcon from "@mui/icons-material/Attachment";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import VideoCallIcon from "@mui/icons-material/VideoCall";
import {
  Collapse,
  DialogContentText,
  IconButton,
  TextField,
  Zoom,
} from "@mui/material";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardHeader from "@mui/material/CardHeader";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Icon from "@mui/material/Icon";
import Typography from "@mui/material/Typography/Typography";
import { useEffect, useState } from "react";
import ImageDesigner from "react-image-designer";
import { Lightbox } from "react-modal-image";
import { Document, Page, pdfjs } from "react-pdf";
import ReactPlayer from "react-player";
import { connect, useStore } from "react-redux";
import { useLocation } from "react-router-dom";
import { makeStyles } from "tss-react/mui";
import { v4 as uuidv4 } from "uuid";
import { config_UPTIME } from "../../Constants";
import { getSingleMachine } from "../../actions/machines";
import { getNotification } from "../../actions/notification";
import {
  createGenericAttachment,
  deleteGenericAttachment,
} from "../../actions/objects";
import photoPlaceholder from "../../assets/photo-placeholder.svg";
import DeletePopupByNodeId from "../../components/DeletePopupByNodeId";
import axios, * as others from "axios";
import UploadAttachmentModal from "../../components/UploadAttachmentModal";
import {
  allow_docs_mimetypes,
  allow_images_mimetypes,
  allow_videos_mimetypes,
  getFileExtention,
  images_enum,
  videos_enum,
} from "../../utils/helpers";
import { ReactComponent as Magnifier } from "../../assets/magnifier.svg";
import clsx from "clsx";
import ExpandLessRoundedIcon from "@mui/icons-material/ExpandLessRounded";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import mime from "mime";
import { getItem } from "../../utils/DataProtection";
import * as $ from "jquery";

(async () => {
  pdfjs.GlobalWorkerOptions.workerSrc = await `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;
})();

const useStyles = makeStyles()((theme) => ({
  headlineSpacer: {
    marginTop: 38,
  },
  uploadedMediaContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    // marginBottom: 20
  },
  deleteButton: {
    display: "flex",
    alignItems: "flex-end",
    background: "none",
    border: "none",
    color: "gray",
    padding: 0,
  },
  mediaWrapper: {
    backgroundColor: "transparent",
    borderWidth: 0,
    padding: 0,
    boxShadow: "none",
    width: "214px",
    height: "139px",
    // height: 80,
    borderRadius: theme.roundness,
    overflow: "hidden",
    // marginRight: 16,

    "& img": {
      width: "100%",
      minHeight: "100%",
      height: "auto !important",
    },
  },
  videoPlayer: {
    borderRadius: theme.roundness,
    overflow: "hidden",
    marginRight: 16,
  },
  cardButtonLarge: {
    minWidth: 250,
    marginRight: 16,

    "& .mdi-icon, & .MuiSvgIcon-root": {
      ...theme.largeCardIcon,
    },
  },
  cardButton: {
    minWidth: 220,
    width: 332,
    height: 56,
    marginTop: 10,
  },
  pdfViewerButtons: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
}));

export default connect(
  ({ filesUrlsNI, notification, machines }) => ({
    filesUrlsNI,
    notification,
    machines,
  }),
  {
    createGenericAttachment,
    getSingleMachine,
    deleteGenericAttachment,
    getNotification,
  }
)((props) => {
  const [showButtn, setShowButton] = useState(true); // to avoid double click
  const [target, setTarget] = useState();
  const i18n = useStore().getState().i18n;
  const store = useStore().getState();
  let location = props.propLocation ? props.propLocation : useLocation();
  const [numPages, setnumPages] = useState(null);
  const [pageNumber, setpageNumber] = useState(1);
  const [isOpen, setisOpen] = useState(false);
  const [large, setlarge] = useState("");
  const [openDialog, setopenDialog] = useState(false);
  const [nextDisabled, setnextDisabled] = useState(false);
  const [prevDisabled, setprevDisabled] = useState(true);
  const [pdfLink, setpdfLink] = useState("");
  const [documentLoaded, setDocumentLoaded] = useState(false);

  const [noti_images, setnoti_images] = useState([]);
  const [noti_image_data, setnoti_image_data] = useState([]);
  const [loader, setloader] = useState(false);

  const [noti_video, setnoti_video] = useState([]);
  const [noti_video_data, setnoti_video_data] = useState([]);
  const [loaderVedio, setloaderVedio] = useState(false);

  const [noti_docs, setnoti_docs] = useState([]);
  const [noti_docs_data, setnoti_docs_data] = useState([]);
  const [loaderDocs, setloaderDocs] = useState(false);

  const [values, setvalues] = useState({});
  const [UploadDialog, setUploadDialog] = useState(false);
  const [fileid, setfileid] = useState();
  const [titleManu, settitleManu] = useState("");
  const [description, setdescription] = useState("");

  const [uploadUrl, setuploadUrl] = useState();
  const [bucketid, setbucketid] = useState();
  const [Newfile, setNewfile] = useState();
  const [fileVersion, setFileVersion] = useState("");
  const [AttachmentNodeid, setAttachmentNodeid] = useState();

  const [moreImages, setMoreImages] = useState([]);
  const [moreVideos, setMoreVideos] = useState([]);
  const [moreDocs, setMoreDocs] = useState([]);

  const [showMoreImages, setShowMoreImages] = useState(false);

  const { classes } = useStyles();

  const onDocumentLoadSuccess = (totalPages) => {
    setnumPages(totalPages);
    if (totalPages == 1) {
      setnextDisabled(true);
    }
    setDocumentLoaded(true);
  };
  const onImgClick = (e, url) => {
    e.preventDefault();
    setisOpen(true);
    setlarge(url);
  };

  const closeLightbox = () => {
    setisOpen(false);
  };

  const handleCloseDialog = () => {
    setopenDialog(false);
  };

  const handleNextPage = () => {
    setpageNumber(pageNumber + 1);
    if (pageNumber > 0) {
      setprevDisabled(false);
    }

    if (pageNumber == numPages - 1) {
      setnextDisabled(true);
    }
  };

  const handlePrevPage = () => {
    setpageNumber(pageNumber - 1);
    if (pageNumber > 1) {
      setnextDisabled(false);
    }
    if (pageNumber == 2) {
      setprevDisabled(true);
    }
  };

  const [preImages, setPreImages] = useState([]);
  const [preVideos, setPreVideos] = useState([]);
  const [preDocs, setPreDocs] = useState([]);


  const deleteLocalFile = () => {
    let nodeidClass = localStorage.getItem("delNodeidClass");
    if (nodeidClass) {
      $('[class*="' + nodeidClass.trim() + '"]').css("display","none");
    localStorage.removeItem("delNodeidClass");
    }
  }

  useEffect(() => {
    var images = [];
    var videos = [];
    var docs = [];

    setPreImages([]);
    setPreVideos([]);
    setPreDocs([]);

    if (
      props.notification &&
      props.attachmentsOf === "notification" && 
      props.notification?.notification?.hasattachment !== undefined &&
      props.notification?.notification?.hasattachment.length > 0
    ) {
      props.notification.notification.hasattachment.map((i, k) => {
        var mime = i?.attachment?.file?.mimetype;
        if (allow_images_mimetypes.includes(mime)) {
          images.push({
            nodeid: i?.attachment?.nodeid,
            url: i?.attachment?.file?.url,
            uuid: uuidv4(),
          });
        } else if (mime?.includes("video")) {
          videos.push({
            nodeid: i?.attachment?.nodeid,
            url: i?.attachment?.file?.url,
            uuid: uuidv4(),
          });
        } else if (allow_docs_mimetypes.includes(mime)) {
          docs.push({
            nodeid: i?.attachment?.nodeid,
            url: i?.attachment?.file?.url,
            title: i?.attachment?.title,
            description: i?.attachment?.description,
            mimetype: mime,
            uuid: uuidv4(),
          });
        }
      });
      setPreImages(images);
      setPreVideos(videos);
      setPreDocs(docs);
    }

    if (
      props.workflowAttachments &&
      props.workflowAttachments.length > 0 &&
      (props.attachmentsOf === "solution" ||
        props.attachmentsOf === "faq" ||
        props.attachmentsOf === "report" ||
        props.attachmentsOf === "maintenanceTask")
    ) {
      images = [];
      videos = [];
      docs = [];

      props.workflowAttachments.map((i, k) => {
        var mime = i?.attachment?.file?.mimetype;

        if (allow_images_mimetypes.includes(mime)) {
          images.push({
            nodeid: i?.attachment?.nodeid,
            url: i?.attachment?.file?.url,
            uuid: uuidv4(),
          });
        } else if (mime?.includes("video")) {
          videos.push({
            nodeid: i?.attachment?.nodeid,
            url: i?.attachment?.file?.url,
            uuid: uuidv4(),
          });
        } else if (allow_docs_mimetypes.includes(mime)) {
          docs.push({
            nodeid: i?.attachment?.nodeid,
            url: i?.attachment?.file?.url,
            title: i?.attachment?.title,
            description: i?.attachment?.description,
            mimetype: mime,
            uuid: uuidv4(),
          });
        }
      });
      setPreImages(images);
      setPreVideos(videos);
      setPreDocs(docs);
    } else if (
      location.state &&
      location.state.workflowAttachments &&
      location.state.workflowAttachments.length > 0 && props.from !== "maintenance_task_template"
    ) {
      images = [];
      videos = [];
      docs = [];

      location.state.workflowAttachments.map((i, k) => {
        var mime = i?.attachment?.file?.mimetype;
        if (allow_images_mimetypes.includes(mime)) {
          images.push({
            nodeid: i?.attachment?.nodeid,
            url: i?.attachment?.file?.url,
            uuid: uuidv4(),
          });
        } else if (mime?.includes("video")) {
          videos.push({
            nodeid: i?.attachment?.nodeid,
            url: i?.attachment?.file?.url,
            uuid: uuidv4(),
          });
        } else if (allow_docs_mimetypes.includes(mime)) {
          docs.push({
            nodeid: i?.attachment?.nodeid,
            url: i?.attachment?.file?.url,
            title: i?.attachment?.title,
            description: i?.attachment?.description,
            mimetype: mime,
            uuid: uuidv4(),
          });
        }
      });
      setPreImages(images);
      setPreVideos(videos);
      setPreDocs(docs);
    } else if (
      props.questionanswerAttachments &&
      props.questionanswerAttachments.length > 0
    ) {
      images = [];
      videos = [];
      docs = [];

      props.questionanswerAttachments.map((i, k) => {
        var mime = i?.attachment?.file?.mimetype;
        if (allow_images_mimetypes.includes(mime)) {
          images.push({
            nodeid: i?.attachment?.nodeid,
            url: i?.attachment?.file?.url,
            uuid: uuidv4(),
          });
        } else if (mime?.includes("video")) {
          videos.push({
            nodeid: i?.attachment?.nodeid,
            url: i?.attachment?.file?.url,
            uuid: uuidv4(),
          });
        } else if (allow_docs_mimetypes.includes(mime)) {
          docs.push({
            nodeid: i?.attachment?.nodeid,
            url: i?.attachment?.file?.url,
            title: i?.attachment?.title,
            description: i?.attachment?.description,
            mimetype: mime,
            uuid: uuidv4(),
          });
        }
      });
      setPreImages(images);
      setPreVideos(videos);
      setPreDocs(docs);
    } else if (
      location.state &&
      location.state.questionanswerAttachments &&
      location.state.questionanswerAttachments.length > 0
    ) {
      images = [];
      videos = [];
      docs = [];

      location.state.questionanswerAttachments.map((i, k) => {
        var mime = i?.attachment?.file?.mimetype;
        if (allow_images_mimetypes.includes(mime)) {
          images.push({
            nodeid: i?.attachment?.nodeid,
            url: i?.attachment?.file?.url,
            uuid: uuidv4(),
          });
        } else if (mime?.includes("video")) {
          videos.push({
            nodeid: i?.attachment?.nodeid,
            url: i?.attachment?.file?.url,
            uuid: uuidv4(),
          });
        } else if (allow_docs_mimetypes.includes(mime)) {
          docs.push({
            nodeid: i?.attachment?.nodeid,
            url: i?.attachment?.file?.url,
            title: i?.attachment?.title,
            description: i?.attachment?.description,
            mimetype: mime,
            uuid: uuidv4(),
          });
        }
      });
      setPreImages(images);
      setPreVideos(videos);
      setPreDocs(docs);
    }

    setTimeout(() => {
     deleteLocalFile()
    }, 1000);

    return () => {
      // Unmount states
      if (!props.edit) {
        setPreImages([]);
        setPreVideos([]);
        setPreDocs([]);
      }
    };
  }, [props]);

  const docsDialog = (i) => {
    /* console.log("oo->"+i) */
    setpdfLink(i);
    setopenDialog(true);
  };

  const handleNewImage = async (e) => {
    setloader(true);
    e.preventDefault();
    var imageSrc = e.target.files[0];

    if (e.target.files.length == 0) {
      setloader(false);
      return false;
    }

    let myFile = e.target.files[0];

    const exstention = getFileExtention(myFile?.type);
    var myImages = [];
    myImages = noti_images;

    var index =
      Math.floor(Math.random() * 90000) +
      10000 +
      Math.floor(Math.random() * 30000) +
      10000;

    const imgObj = {
      src: URL.createObjectURL(imageSrc),
      index: index,
      uuid: uuidv4(),
    };

    myImages.push(imgObj);

    setnoti_images(myImages);

    myImages = [];
    //get file id

    const user_token = getItem("user");
    const url = config_UPTIME.url.API_URL + "/files";
    const method = "POST";
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + JSON.parse(user_token),
      },
    };
    const nodeid = config_UPTIME.url.UPTIME_DEFAULT_URL + uuidv4();
    const exstension_payload = [{ nodeid: nodeid, extension: exstention }];
    const response = await axios
      .post(
        url,
        {
          count: 1,
          extensions: exstension_payload,
        },
        config
      )
      .then((res) => {
        var arr = [];

        return res;
      })
      .catch(function(error) {
        //console.log(error);
      });

    let image_data = noti_image_data;
    var mime_type = "";
    // if (exstention[1] == "png") {

    //   mime_type = 'image/png'
    // }
    // else if (exstention[1] == "jpg" || exstention[1] == "jpeg") {
    //   mime_type = 'image/jpeg'

    // }
    image_data.push({
      nodeid: nodeid,
      index: imgObj.index,
      fileid: response?.data[0]?.fileid,
      url: response?.data[0]?.url,
      image: imageSrc,
      mime: myFile.type,
      bucketid: response?.data[0]?.bucketid,
      fileversion: response?.data[0]?.fileversion,
    });

    setnoti_image_data(image_data);

    setloader(false);

    props.fromChildToParentCallback(
      image_data,
      noti_video_data,
      noti_docs_data
    );
  };

  const handleNewVideo = async (e, from) => {
    setloader(true);
    // e.preventDefault();

    var myFile = e.target.files[0];
    if (e.target.files.length == 0) {
      setloader(false);
      return false;
    }
    const exstention = getFileExtention(myFile?.type);
    var myImages = [];
    myImages = noti_video;

    var index =
      Math.floor(Math.random() * 90000) +
      10000 +
      Math.floor(Math.random() * 30000) +
      10000;

    const imgObj = {
      src: URL.createObjectURL(myFile),
      index: index,
      mimetype: myFile.type,
      uuid: uuidv4(),
    };

    myImages.push(imgObj);

    setnoti_video(myImages);

    myImages = [];

    //get file id

    const user_token = getItem("user");
    const url = config_UPTIME.url.API_URL + "/files";
    const method = "POST";
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + JSON.parse(user_token),
      },
      onUploadProgress: (e) => {
      },
    };
    const nodeid = config_UPTIME.url.UPTIME_DEFAULT_URL + uuidv4();
    const exstension_payload = [{ nodeid: nodeid, extension: exstention }];

    const response = await axios
      .post(
        url,
        {
          count: 1,
          extensions: exstension_payload,
        },
        config
      )
      .then((res) => {
        var arr = [];

        return res;
      })
      .catch(function(error) {
        //console.log(error);
      });

    const image_data = noti_video_data;
    // var mime_type = ''
    // if (exstention[1] == "mp4") {

    //   mime_type = 'video/mp4'
    // }
    image_data.push({
      nodeid: nodeid,
      index: imgObj.index,
      fileid: response.data[0].fileid,
      url: response.data[0].url,
      image: myFile,
      mime: myFile.type,
      bucketid: response.data[0].bucketid,
      fileversion: response.data[0].fileversion,
    });

    setnoti_video_data(image_data);

    setloader(false);

    props.fromChildToParentCallback(
      noti_image_data,
      image_data,
      noti_docs_data
    );
  };

  const handleNewDoc = async (e, from) => {
    setloaderDocs(true);
    // e.preventDefault();
    var myFile = e.target.files[0];
    /* console.log(myFile); */
    if (e.target.files.length == 0) {
      setloader(false);
      return false;
    }
    const exstention = getFileExtention(myFile?.type);
    setNewfile(e.target.files[0]);
    var myImages = [];
    myImages = noti_docs;

    //get file id

    const user_token = getItem("user");
    const url = config_UPTIME.url.API_URL + "/files";
    const method = "POST";
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + JSON.parse(user_token),
      },
    };
    const nodeid = config_UPTIME.url.UPTIME_DEFAULT_URL + uuidv4();

    var index =
      Math.floor(Math.random() * 90000) +
      10000 +
      Math.floor(Math.random() * 30000) +
      10000;

    const imgObj = {
      src: URL.createObjectURL(myFile),
      index: index,
      name: titleManu === "" ? myFile.name.split(".")[0] : titleManu,
      nodeid: nodeid,
      mimetype: myFile.type,
      uuid: uuidv4(),
    };

    myImages.push(imgObj);

    setnoti_docs(myImages);

    myImages = [];

    setAttachmentNodeid(nodeid);
    const exstension_payload = [{ nodeid: nodeid, extension: exstention }];

    const response = await axios
      .post(
        url,
        {
          count: 1,
          extensions: exstension_payload,
        },
        config
      )
      .then((res) => {
        var arr = [];
        setfileid(res.data[0].fileid);
        setuploadUrl(res.data[0].url);
        setbucketid(res.data[0].bucketid);
        setFileVersion(res.data[0].fileversion);

        return res;
      })
      .catch(function(error) {
        //console.log(error);
      });

    const image_data = noti_docs_data;
    // var mime_type = ''
    // if (exstention[1] == "pdf") {

    //   mime_type = 'application/pdf'
    // }

    /* console.log(response,"hahahhahahha") */
    image_data.push({
      nodeid: nodeid,
      index: imgObj.index,
      fileid: response.data[0].fileid,
      url: response.data[0].url,
      image: myFile,
      mime: myFile.type,
      bucketid: response.data[0].bucketid,
      fileversion: response.data[0].fileversion,
      title: titleManu === "" ? myFile.name.split(".")[0] : titleManu,
      description: description,
    });

    setloaderDocs(false);

    setnoti_docs_data(image_data);

    props.fromChildToParentCallback(
      noti_image_data,
      noti_video_data,
      image_data
    );

    setShowButton(true);
    handleClose();
  };

  /* console.log(preDocs, "preDocs"); */

  const handleClickOpen = () => {
    setUploadDialog(true);
  };

  // const submitForm = (e) => {
  //   e.preventDefault();

  //   if (props.edit) {
  //     const url = uploadUrl;
  //     const config = {
  //       headers: {
  //         "Content-Type": Newfile?.type,
  //         "Access-Control-Allow-Origin": "*",
  //       },
  //     };
  //     const response = axios
  //       .put(url, Newfile, config)
  //       .then((res) => {
  //         //console.log(res.data)
  //       })
  //       .catch(function(error) {
  //         //console.log(error);
  //       });
  //     const lang = store.language;
  //     const file = {
  //       fileid: fileid,
  //       mimetype: Newfile.type,
  //       bucketid: bucketid,
  //       fileversion: fileVersion,
  //     };
  //     const isattachmentof = props.nodeId;
  //     const specifier = props.specifier;
  //     const title = titleManu === "" ? Newfile.name.split(".")[0] : titleManu;
  //     const nodeid = AttachmentNodeid;

  //     props.createGenericAttachment(
  //       { lang, description, file, isattachmentof, specifier, title, nodeid },
  //       "genericAttachment"
  //     );
  //   }

  //   const myArray = noti_docs;
  //   if (myArray.length) {
  //     const indexToUpdate = myArray.length - 1;
  //     const updatedName =
  //       titleManu === "" ? Newfile.name.split(".")[0] : titleManu;
  //     myArray[indexToUpdate].name = updatedName;
  //     setnoti_docs(myArray);

  //     const preData = noti_docs_data;
  //     preData[indexToUpdate].title =
  //       titleManu === "" ? Newfile.name.split(".")[0] : titleManu;
  //     setnoti_docs_data(preData);
  //   }
  //   handleClose();
  // };
  const handleClose = () => {
    setfileid("");
    settitleManu("");
    setNewfile();
    setdescription();
    setUploadDialog(false);
  };
  const [openDialogDelete, setopenDialogDelete] = useState(false);
  const [deleteNodeId, setDeleteNodeId] = useState();

  const [navigate, setNavigate] = useState(false);

  const [refresh, setRefresh] = useState(false);

  const handleDialogDelete = () => {
    setopenDialogDelete(false);
  };

  const handleDelete = (nodeid) => {
    setopenDialogDelete(true);
    setDeleteNodeId(nodeid);
  };

  const handleDeleteImageOnPage = (key, index) => {
    setnoti_images((prevImages) => {
      const newImages = [...prevImages];
      newImages.splice(key, 1);
      return newImages;
    });

    const array = noti_images.filter((obj) => obj.index !== index);
    const arrayPost = noti_image_data.filter((obj) => obj.index !== index);
    /* setnoti_images(array) */
    setnoti_image_data(arrayPost);
    props.fromChildToParentCallback(arrayPost, noti_video_data, noti_docs_data);
  };

  const handleDeleteVedioOnPage = (index) => {
    const array = noti_video.filter((obj) => obj.index !== index);
    const arrayPost = noti_video_data.filter((obj) => obj.index !== index);
    setnoti_video(array);
    setnoti_video_data(arrayPost);
    props.fromChildToParentCallback(noti_image_data, arrayPost, noti_docs_data);
  };

  const handleDeleteDocOnPage = (index) => {
    const array = noti_docs.filter((obj) => obj.index !== index);
    const arrayPost = noti_docs_data.filter((obj) => obj.index !== index);
    setnoti_docs(array);
    setnoti_docs_data(arrayPost);
    props.fromChildToParentCallback(
      noti_image_data,
      noti_video_data,
      arrayPost
    );
  };

  const handleDeleteClose = () => {
    setopenDialogDelete(false);
  };

  const handleShowMoreImages = () => {
    setShowMoreImages((prev) => !prev);
  };

  return (
    <>
      {openDialogDelete ? (
        <DeletePopupByNodeId
          from={props.from}
          nodeid={deleteNodeId}
          open={openDialogDelete}
          rootNodeId={props.rootNodeId}
          close={handleDeleteClose}
          deleteCallback={props?.deleteCallback}
        ></DeletePopupByNodeId>
      ) : (
        ""
      )}
      <div>
        {isOpen && (
          <Lightbox
            large={large}
            alt={i18n.image_here}
            hideZoom={false}
            showRotate={true}
            onClose={closeLightbox}
          />
        )}

        {/*  Photos */}

        {preImages.length ? (
          <>
            <Typography
              variant="h2"
              component="h3"
              className={classes.headlineSpacer}
            >
              {i18n.heading_photos}
            </Typography>
            <div
              className={classes.uploadedMediaContainer}
              style={{ display: "flex", flexWrap: "wrap" }}
            >
              {preImages && preImages.length > 0
                ? (props.edit ? preImages : preImages.slice(0, 3))?.map(
                    (i, e) => {
                      return (
                        <div
                          style={{
                            display: "flex",
                            margin: "12px 12px 12px 0px",
                            position: "relative",
                          }}
                          key={i.nodeid}
                      className={" dl-" + i?.nodeid?.split("247fn://247uptime.io/")[1]}
                        >
                          <button
                            className={clsx(
                              classes.mediaWrapper,
                              " bxShadow"
                            )}
                          >
                            <ImageDesigner
                              src={i.url}
                              placeholder={photoPlaceholder}
                            />
                            <div
                              className="magnifier"
                              style={{
                                top: "66%",
                                left: props.edit ? "70%" : "78%",
                              }}
                            >
                              <Magnifier
                                onClick={(e) => {
                                  onImgClick(e, i.url);
                                }}
                              />
                            </div>
                          </button>
                          {props.edit ? (
                            <IconButton
                              className={classes.deleteButton}
                              onClick={() => handleDelete(i.nodeid)}
                            >
                              <Delete />
                            </IconButton>
                          ) : (
                            ""
                          )}
                        </div>
                      );
                    }
                  )
                : ""}
            </div>
          </>
        ) : (
          ""
        )}

        {!props.edit && preImages.length > 3 ? (
          <div onClick={handleShowMoreImages} className="showMore">
            <div>
              {i18n.show_n_more.replace("%s", preImages.slice(3).length)}
            </div>{" "}
            <div className="icon">
              {" "}
              {showMoreImages ? (
                <ExpandLessRoundedIcon />
              ) : (
                <ExpandMoreRoundedIcon />
              )}
            </div>
          </div>
        ) : (
          ""
        )}

        {!props.edit && preImages.length > 3 ? (
          <>
            <Collapse in={showMoreImages} timeout="auto" unmountOnExit>
              <div
                className={classes.uploadedMediaContainer}
                style={{ display: "flex", flexWrap: "wrap" }}
              >
                {preImages.slice(3)?.map((i, e) => {
                  return (
                    <div
                      style={{
                        display: "flex",
                        margin: "12px 12px 12px 0px",
                        position: "relative",
                      }}
                      key={i.nodeid}
                      className={" dl-" + i?.nodeid?.split("247fn://247uptime.io/")[1]}
                    >
                      <button
                        className={clsx(
                          classes.mediaWrapper,
                          " bxShadow",
                         
                        )}
                      >
                        <ImageDesigner
                          src={i.url}
                          placeholder={photoPlaceholder}
                        />
                        <div
                          className="magnifier"
                          style={{
                            top: "66%",
                            left: props.edit ? "70%" : "78%",
                          }}
                        >
                          <Magnifier
                            onClick={(e) => {
                              onImgClick(e, i.url);
                            }}
                          />
                        </div>
                      </button>
                      {props.edit ? (
                        <IconButton
                          className={classes.deleteButton}
                          onClick={() => handleDelete(i.nodeid)}
                        >
                          <Delete />
                        </IconButton>
                      ) : (
                        ""
                      )}
                    </div>
                  );
                })}
              </div>
            </Collapse>
          </>
        ) : (
          ""
        )}

        {/* {!props.edit && preImages.length === 0 ? (
          <Typography variant="body_2" style={{ color: "#C9C6C5" }}>
            {i18n.none_uploaded}
          </Typography>
        ) : (
          false
        )} */}

        <div style={{ display: "flex", flexWrap: "wrap" }}>
          {noti_images.length <= 0
            ? ""
            : noti_images.map((image, k) => {
                return (
                  <div
                    style={{ display: "flex", margin: "12px 12px 12px 0px" }}
                    key={image.uuid}
                  >
                    <button
                      className={classes.mediaWrapper}
                      onClick={(e) => {
                        onImgClick(e, image.src);
                      }}
                    >
                      <ImageDesigner
                        src={image.src}
                        placeholder={photoPlaceholder}
                      />
                    </button>
                    <IconButton
                      className={classes.deleteButton}
                      onClick={() => handleDeleteImageOnPage(k, image.index)}
                    >
                      <Delete />
                    </IconButton>
                  </div>
                );
              })}
        </div>

        {props.edit ? (
          <>
            {loader ? <CircularProgress /> : false}
            <Card className={classes.cardButton} variant="outlined">
              <input
                id="myInput"
                style={{ display: "none" }}
                accept={images_enum}
                type="file"
                data-testid="upload_img_file"
                onChange={handleNewImage}
              />
              <CardActionArea>
                <label htmlFor="myInput">
                  <CardHeader
                    className="NT_cardHeader"
                    avatar={
                      <Icon color="primary" className={classes.cardIcon}>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <mask
                            id="mask0_3115_10382"
                            style={{ maskType: "alpha" }}
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="24"
                            height="24"
                          >
                            <rect width="24" height="24" fill="#D9D9D9" />
                          </mask>
                          <g mask="url(#mask0_3115_10382)">
                            <path
                              d="M11 18.5C12.25 18.5 13.3127 18.0627 14.188 17.188C15.0627 16.3127 15.5 15.25 15.5 14C15.5 12.75 15.0627 11.6873 14.188 10.812C13.3127 9.93733 12.25 9.5 11 9.5C9.75 9.5 8.68733 9.93733 7.812 10.812C6.93733 11.6873 6.5 12.75 6.5 14C6.5 15.25 6.93733 16.3127 7.812 17.188C8.68733 18.0627 9.75 18.5 11 18.5ZM3 22C2.45 22 1.97933 21.8043 1.588 21.413C1.196 21.021 1 20.55 1 20V8C1 7.45 1.196 6.97933 1.588 6.588C1.97933 6.196 2.45 6 3 6H6.15L7.4 4.65C7.58333 4.45 7.804 4.29167 8.062 4.175C8.32067 4.05833 8.59167 4 8.875 4H13C13.2833 4 13.521 4.09567 13.713 4.287C13.9043 4.479 14 4.71667 14 5V8H3V20H19V11H20C20.1333 11 20.2627 11.025 20.388 11.075C20.5127 11.125 20.621 11.1957 20.713 11.287C20.8043 11.379 20.875 11.4873 20.925 11.612C20.975 11.7373 21 11.8667 21 12V20C21 20.55 20.8043 21.021 20.413 21.413C20.021 21.8043 19.55 22 19 22H3ZM19 6H18C17.7167 6 17.4793 5.90433 17.288 5.713C17.096 5.521 17 5.28333 17 5C17 4.71667 17.096 4.479 17.288 4.287C17.4793 4.09567 17.7167 4 18 4H19V3C19 2.71667 19.096 2.479 19.288 2.287C19.4793 2.09567 19.7167 2 20 2C20.2833 2 20.5207 2.09567 20.712 2.287C20.904 2.479 21 2.71667 21 3V4H22C22.2833 4 22.5207 4.09567 22.712 4.287C22.904 4.479 23 4.71667 23 5C23 5.28333 22.904 5.521 22.712 5.713C22.5207 5.90433 22.2833 6 22 6H21V7C21 7.28333 20.904 7.521 20.712 7.713C20.5207 7.90433 20.2833 8 20 8C19.7167 8 19.4793 7.90433 19.288 7.713C19.096 7.521 19 7.28333 19 7V6Z"
                              fill="black"
                              fillOpacity="0.5"
                            />
                          </g>
                        </svg>
                      </Icon>
                    }
                    title={i18n.button_upload_photo}
                  />
                </label>
              </CardActionArea>
            </Card>
          </>
        ) : (
          false
        )}

        {/*  Videos */}
        {preVideos.length ? (
          <Typography
            variant="h2"
            component="h3"
            className={classes.headlineSpacer}
          >
            {i18n.heading_videos}
          </Typography>
        ) : (
          ""
        )}
        <div
          className={classes.uploadedMediaContainer}
          style={{ marginTop: "10px" }}
        >
          {preVideos && preVideos.length > 0 ? (
            preVideos?.map((i, e) => {
              return (
                <div
                  style={{ display: "flex", margin: "12px 0px" }}
                  key={i.uuid}
                  className={
                    " dl-" + i?.nodeid?.split("247fn://247uptime.io/")[1]
                  }
                >
                  <ReactPlayer
                    className={classes.videoPlayer}
                    width={200}
                    height="auto"
                    url={i.url}
                    controls={true}
                  />
                  {props.edit ? (
                    <IconButton
                      className={classes.deleteButton}
                      onClick={() => handleDelete(i.nodeid)}
                    >
                      <Delete />
                    </IconButton>
                  ) : (
                    ""
                  )}
                </div>
              );
            })
          ) : !props.edit ? (
            // <Typography variant="body_2" style={{ color: "#C9C6C5" }}>
            //   {i18n.none_uploaded}
            // </Typography>
            <></>
          ) : (
            false
          )}
          {noti_video.length <= 0
            ? ""
            : noti_video.map((vedio, index) => {
                return (
                  <div
                    style={{ display: "flex", margin: "12px 0px" }}
                    key={vedio.uuid}
                    className={
                      " dl-" + vedio?.nodeid?.split("247fn://247uptime.io/")[1]
                    }
                  >
                    <ReactPlayer
                      className={classes.videoPlayer}
                      width={200}
                      height="auto"
                      url={vedio.src}
                      controls={true}
                    />
                    <IconButton
                      className={classes.deleteButton}
                      onClick={() => handleDeleteVedioOnPage(vedio.index)}
                    >
                      <Delete />
                    </IconButton>
                  </div>
                );
              })}
        </div>

        {props.edit ? (
          <Card
            className={clsx(classes.cardButton)}
            variant="outlined"
            style={{ margin: "10px 0px 0px 0px" }}
          >
            <input
              id="myInputVideo"
              style={{ display: "none" }}
              accept={videos_enum}
              data-testid="upload_vid_file"
              type="file"
              onChange={handleNewVideo}
            />
            <CardActionArea className="videoCardAction">
              <label htmlFor="myInputVideo">
                <CardHeader
                  className="NT_cardHeader"
                  style={{
                    border: "1px solid rgba(0, 0, 0, 0.12) !important;",
                  }}
                  avatar={
                    <Icon color="primary" className={classes.cardIcon}>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_3115_10580"
                          style={{ maskType: "alpha" }}
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="24"
                          height="24"
                        >
                          <rect width="24" height="24" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_3115_10580)">
                          <path
                            d="M10 16C10.2833 16 10.5208 15.9042 10.7125 15.7125C10.9042 15.5208 11 15.2833 11 15V13H13C13.2833 13 13.5208 12.9042 13.7125 12.7125C13.9042 12.5208 14 12.2833 14 12C14 11.7167 13.9042 11.4792 13.7125 11.2875C13.5208 11.0958 13.2833 11 13 11H11V9C11 8.71667 10.9042 8.47917 10.7125 8.2875C10.5208 8.09583 10.2833 8 10 8C9.71667 8 9.47917 8.09583 9.2875 8.2875C9.09583 8.47917 9 8.71667 9 9V11H7C6.71667 11 6.47917 11.0958 6.2875 11.2875C6.09583 11.4792 6 11.7167 6 12C6 12.2833 6.09583 12.5208 6.2875 12.7125C6.47917 12.9042 6.71667 13 7 13H9V15C9 15.2833 9.09583 15.5208 9.2875 15.7125C9.47917 15.9042 9.71667 16 10 16ZM4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H16C16.55 4 17.0208 4.19583 17.4125 4.5875C17.8042 4.97917 18 5.45 18 6V10.5L21.15 7.35C21.3 7.2 21.4792 7.1625 21.6875 7.2375C21.8958 7.3125 22 7.46667 22 7.7V16.3C22 16.5333 21.8958 16.6875 21.6875 16.7625C21.4792 16.8375 21.3 16.8 21.15 16.65L18 13.5V18C18 18.55 17.8042 19.0208 17.4125 19.4125C17.0208 19.8042 16.55 20 16 20H4ZM4 18H16V6H4V18Z"
                            fill="black"
                            fillOpacity="0.5"
                          />
                        </g>
                      </svg>
                    </Icon>
                  }
                  title={i18n.button_upload_video}
                />
              </label>
            </CardActionArea>
          </Card>
        ) : (
          false
        )}

        {/* Attachments */}

        {preDocs.length ? (
          <Typography
            variant="h2"
            component="h3"
            className={classes.headlineSpacer}
          >
            {i18n.attachments}
          </Typography>
        ) : (
          ""
        )}
        <div
          className={clsx(classes.uploadedMediaContainer)}
          style={{ display: "flex", flexWrap: "wrap" }}
        >
          {preDocs && preDocs.length > 0 ? (
            preDocs?.map((i, e) => {
              let mimeType = mime?.getExtension(i?.mimetype);
              return (
                <div
                  style={{ display: "flex", margin: "12px 0px" }}
                  key={i?.uuid}
                  className={
                    " dl-" + i?.nodeid?.split("247fn://247uptime.io/")[1]
                  }
                >
                  <Card
                    className={classes.cardButtonLarge}
                    variant="outlined"
                    onClick={() => {
                      mimeType === "pdf"
                        ? docsDialog(i.url)
                        : window.open(i?.url, "PDF Viewer");
                    }}
                  >
                    <CardActionArea
                      sx={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}
                    >
                      <CardHeader
                        avatar={
                          <Icon color="primary" className={classes.cardIcon}>
                            <AttachmentIcon />
                          </Icon>
                        }
                        style={{ height: "70px" }}
                        subheader={
                          <div className="attachmentWrapper">
                            <div className="content">
                              <div className="attachmentHeader">
                                {i.title ? i.title : i18n.no_workflow_title}{" "}
                                <span
                                  style={{ marginLeft: "2px" }}
                                  className="mimeType"
                                >
                                  {mimeType ? mimeType : "no_type"}{" "}
                                </span>
                              </div>
                              <div
                                className="attachmentSubHeader"
                                style={{
                                  width: "max-content",
                                  whiteSpace: "pre-wrap",
                                }}
                              >
                                {i.description ? i.description : ""}{" "}
                              </div>
                            </div>
                          </div>
                        }
                      />
                    </CardActionArea>
                  </Card>
                  {props.edit ? (
                    <IconButton
                      className={classes.deleteButton}
                      onClick={() => handleDelete(i.nodeid)}
                      style={{ marginBottom: 8 }}
                    >
                      <Delete />
                    </IconButton>
                  ) : (
                    ""
                  )}
                </div>
              );
            })
          ) : !props.edit ? (
            // <Typography variant="body_2" style={{ color: "#C9C6C5" }}>
            //   {i18n.none_uploaded}
            // </Typography>
            <></>
          ) : (
            false
          )}
          {
            //list attachments
            <div style={{ flexBasis: "33.33%", maxWidth: "33.33%" }}>
              {noti_docs.length <= 0
                ? ""
                : noti_docs.map((doc, index) => {
                    let mimeType = mime?.getExtension(doc?.mimetype);
                    return (
                      <div
                        style={{ display: "flex", margin: "12px 0px" }}
                        key={doc?.uuid}
                        className={
                          " dl-" + doc?.nodeid?.split("247fn://247uptime.io/")[1]
                        }
                      >
                        <Card
                          className={classes.cardButtonLarge}
                          variant="outlined"
                          onClick={() => {
                            docsDialog(doc.src);
                          }}
                          style={{ marginBottom: 10 }}
                        >
                          <CardActionArea>
                            <CardHeader
                            className="cardHeader"
                              avatar={
                                <Icon
                                  color="primary"
                                  className={classes.cardIcon}
                                >
                                  <AttachmentIcon />
                                </Icon>
                              }
                              subheader={
                                <span>
                                  {doc.name}{" "}
                                  {/* {doc.description
                                    ? doc.description
                                    : "no description"}{" "} */}
                                  <span
                                    style={{ marginLeft: "2px" }}
                                    className="mimeType"
                                  >
                                    {mimeType}{" "}
                                  </span>
                                </span>
                              }
                            />
                          </CardActionArea>
                        </Card>
                        {location.pathname === "/edit-faq" ? (
                          <IconButton
                            className={classes.deleteButton}
                            onClick={() => handleDelete(doc.nodeid)}
                          >
                            <Delete />
                          </IconButton>
                        ) : (
                          ""
                        )}
                      </div>
                    );
                  })}
            </div>
          }
        </div>

        {//add new doc on edit page
        props.edit ? (
          <div style={{ width: "38%", marginBottom: 10 }}>
            <Card
              className={clsx(classes.cardButton)}
              variant="outlined"
              onClick={handleClickOpen}
              style={{ marginBottom: 10 }}
              data-testid="upload_attachment_model"
            >
              <CardActionArea>
                <CardHeader
                  className="NT_cardHeader"
                  avatar={
                    <Icon color="primary" className={classes.cardIcon}>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_3115_10854"
                          style={{ maskType: "alpha" }}
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="24"
                          height="24"
                        >
                          <rect width="24" height="24" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_3115_10854)">
                          <path
                            d="M7.5 17.5C5.96667 17.5 4.66667 16.9667 3.6 15.9C2.53333 14.8333 2 13.5333 2 12C2 10.4667 2.53333 9.16667 3.6 8.1C4.66667 7.03333 5.96667 6.5 7.5 6.5H18C19.1 6.5 20.0417 6.89167 20.825 7.675C21.6083 8.45833 22 9.4 22 10.5C22 11.6 21.6083 12.5417 20.825 13.325C20.0417 14.1083 19.1 14.5 18 14.5H8.5C7.8 14.5 7.20833 14.2583 6.725 13.775C6.24167 13.2917 6 12.7 6 12C6 11.3 6.24167 10.7083 6.725 10.225C7.20833 9.74167 7.8 9.5 8.5 9.5H17.25C17.4667 9.5 17.646 9.57067 17.788 9.712C17.9293 9.854 18 10.0333 18 10.25C18 10.4667 17.9293 10.6457 17.788 10.787C17.646 10.929 17.4667 11 17.25 11H8.5C8.21667 11 7.97933 11.0957 7.788 11.287C7.596 11.479 7.5 11.7167 7.5 12C7.5 12.2833 7.596 12.5207 7.788 12.712C7.97933 12.904 8.21667 13 8.5 13H18C18.7 13 19.2917 12.7583 19.775 12.275C20.2583 11.7917 20.5 11.2 20.5 10.5C20.5 9.8 20.2583 9.20833 19.775 8.725C19.2917 8.24167 18.7 8 18 8H7.5C6.4 8 5.45833 8.39167 4.675 9.175C3.89167 9.95833 3.5 10.9 3.5 12C3.5 13.1 3.89167 14.0417 4.675 14.825C5.45833 15.6083 6.4 16 7.5 16H17.25C17.4667 16 17.646 16.0707 17.788 16.212C17.9293 16.354 18 16.5333 18 16.75C18 16.9667 17.9293 17.146 17.788 17.288C17.646 17.4293 17.4667 17.5 17.25 17.5H7.5Z"
                            fill="black"
                            fillOpacity="0.5"
                          />
                        </g>
                      </svg>
                    </Icon>
                  }
                  title={i18n.button_upload_attachment}
                />
              </CardActionArea>
            </Card>
            <br></br>
          </div>
        ) : (
          false
        )}
        <Dialog
          sx={{ backdropFilter: "blur(4px)" }}
          open={openDialog}
          onClose={handleCloseDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          TransitionComponent={Zoom}
        >
          <DialogTitle id="alert-dialog-title">
            {"Attachment Title"}
          </DialogTitle>
          <DialogContent>
            <Document
              file={pdfLink}
              onLoadError={(err) => {
              }}
              onLoadSuccess={(pdf) => {
                onDocumentLoadSuccess(pdf.numPages);
              }}
            >
              <Page pageNumber={pageNumber} />
            </Document>
          </DialogContent>
          <DialogActions>
            {documentLoaded ? (
              <div className={classes.pdfViewerButtons}>
                <Button
                  onClick={handlePrevPage}
                  color="primary"
                  disabled={prevDisabled}
                >
                  {i18n.previous}
                </Button>
                <text>
                  {i18n.page} {pageNumber} {i18n.ofPage} {numPages}
                </text>
                <Button
                  onClick={handleNextPage}
                  color="primary"
                  disabled={nextDisabled}
                >
                  {i18n.next}
                </Button>
              </div>
            ) : (
              false
            )}
          </DialogActions>
          <DialogActions>
            <Button href={pdfLink} target="_blank" color="primary">
              {i18n.download}
            </Button>
          </DialogActions>
        </Dialog>

        {/* <Dialog sx={{ backdropFilter: "blur(4px)" }}TransitionComponent={Zoom} open={UploadDialog} onClose={handleClose} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">{i18n.upload_file}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Please upload PDF
            </DialogContentText>
            <label htmlFor="myInputDoc">
              <AddAPhoto color="primary" />
              <br />
            </label>
            <input
              id="myInputDoc"
              style={{ display: 'none' }}
              type={"file"}
              accept=".pdf,.mp4"
              onChange={handleNewDoc}
            />
            fileid:{fileid}
            <TextField
              id="title"
              value={values.title}
              onChange={(e) => {
                settitleManu(e.target.value)
              }}
              margin="dense"
              label={i18n.file_title}
              type="text"
              fullWidth
            />
             <TextField
              id="description"
              value={values.description}
              onChange={(e) => {
                setdescription(e.target.value)
              }}
              margin="dense"
              label={i18n.file_description}
              type="text"
              fullWidth
            /> 
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              {i18n.button_cancel}
            </Button>
            <Button onClick={submitForm} color="primary">
              {i18n.upload_file}
            </Button>
          </DialogActions>
        </Dialog> */}
      </div>
      <UploadAttachmentModal
        hasTitle
        hasDescription
        open={UploadDialog}
        customFileChange={props.customFileChange}
        onClose={handleClose}
        file={Newfile}
        setFile={setNewfile}
        handleSubmit={handleNewDoc}
        description={description}
        setDescription={setdescription}
        title={titleManu}
        setTitle={settitleManu}
        setTarget={setTarget}
        target={target}
        showButtn={showButtn}
        setShowButton={setShowButton}
      />
    </>
  );
});
